var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('gmap-map',{style:({ height: _vm.height, width: _vm.width }),attrs:{"center":_vm.center,"zoom":_vm.internalzoom}},[_c('gmap-marker',{attrs:{"id":"marker","position":_vm.center,"draggable":_vm.draggableMarker},on:{"dragend":_vm.drag}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }